{
  "about": {
    "title": "À propos de Spring Boot Admin",
    "label": "À propos"
  }
}
